import { render, staticRenderFns } from "./IbanOk.vue?vue&type=template&id=42db3e23&"
import script from "./IbanOk.vue?vue&type=script&lang=js&"
export * from "./IbanOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports